export default [{
    name: '首页',
    path: '/',
    icon: 'ios-home-outline',
    authority: 'Manage Edit'
},
{
    name: '台账管理',
    icon: 'ios-book-outline',
    authority: 'Manage',
    path: '/manage/differentProvince',
    // match: ['differentProvince']
},
// {
//     name: '台账更新管理',
//     icon: 'ios-bookmarks-outline',
//     path: '/manage/ledger',
//     authority: 'Manage'
// },
{
    name: '工作调度',
    icon: 'ios-filing-outline',
    // path: '/manage/workScheduling',
    authority: 'Manage Edit',
    children: [
        // {
        //     name: '工作调度管理',
        //     path: '/manage/workScheduling',
        //     authority: 'Manage'
        // },
        {
            name: '工作调度结果',
            path: '/manage/formRecord',
            authority: 'Manage'
        }
    ]
    
},
{
    name: '数据统计',
    icon: 'stats-bars',
    authority: 'Manage Edit',
    children: [
        {
            name: '育人号排序',
            path: '/datastatistics/sort',
            authority: 'Manage Edit'
        }
    ]
},
{
    name: '消息通知管理',
    icon: 'ios-information-outline',
    path: '/information',
    authority: 'Manage'
},
{
    name: '设置',
    icon: 'ios-gear-outline',
    authority: 'Manage Edit',
    children: [{
            name: '账号信息',
            path: '/settings/account',
            authority: 'Manage Edit'
        }
    ]
}

]


// WEBPACK FOOTER //
// ./src/config/secretary.js